import React from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import type { ExperimentMeta } from '../../common/types';

/**
 * This component is used to provide the experiment meta information to the analytics context.
 * It should be used in conjunction with the `useTouchpointEventAnalytics` hook to generate
 * growth attributes for events.
 *
 * @param {ExperimentMeta} experimentMeta - The experiment meta information.
 * @param {React.ReactNode} children - The child components to be rendered.
 */
export const ExperimentAnalyticsContext = ({
	experimentMeta,
	children,
}: {
	children: React.ReactNode;
	experimentMeta: ExperimentMeta;
}): React.JSX.Element => {
	return <AnalyticsContext data={{ attributes: { experimentMeta } }}>{children}</AnalyticsContext>;
};
